export const ALGOLIA_EVENT_INDEX_NAMES = {
  topSoldEvents: 'top_sold_events',
  sortByCreatedAtAsc: 'sort_by_created_at_asc',
  sortByCreatedAtDesc: 'sort_by_created_at_desc',
  sortByPriceAsc: 'sort_by_price_asc',
  querySuggestions: 'query_suggestions',
  topGiftIdeas: 'top_gift_ideas',
  federatedSearch: 'federated_search',
} as const
type AlgoliaEventIndexNames =
  (typeof ALGOLIA_EVENT_INDEX_NAMES)[keyof typeof ALGOLIA_EVENT_INDEX_NAMES]

const ALGOLIA_INDEX_NAMES = {
  localities: 'localities',
  categories: 'categories',
}

export const useAlgoliaIndexNames = () => {
  const { locale } = useI18n()

  const shortLocale = computed(() => getISO2Locale(locale.value))

  const getEventListIndexName = (
    indexName: AlgoliaEventIndexNames | null
  ): string => {
    const names = ['events', shortLocale.value]
    if (indexName) names.push(indexName)
    return names.join('_')
  }
  return {
    localities: ALGOLIA_INDEX_NAMES.localities,
    categories: ALGOLIA_INDEX_NAMES.categories + '_' + shortLocale.value,
    getEventListIndexName,
  }
}
